import { useState } from 'react';
import Utils from '@/common/utils/utils';
import MessageMoreMenu from '../tooltip/MessageMoreMenu';
import {
    isDisplayBtnCopyMsgId,
    isDisplayReactionBtn,
    isEditedMsg,
    onClickShowEditMsg,
    onOpenHistoryDialog
} from '../handler/MessageHandler';
import { IconButton, Tooltip } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const ChatBoxToolKnowledge = ({
    ticketInfo,
    item,
    setChatPostShowFlagMsgCopyMsgId,
    genMessageCopyShortLink,
    isDisplayBtnEdit,
    setOpenModalDeleteMsg,
    selectThread,
    isDisplayBtnDelete,
    setReactionPopoverId,
    setReactionPopover,
    reactionId,
    isEnableChat,
    editedMsgList,
    setIsOpenHistoryDialog,
    setIsLoadingHistoryList,
    setHistoryList,
    setMsgEditSelected,
    userChatList,
    setIsShowModalEditMsg,
    msgRefList,
    chatPostAllList,
    setChatPostUpdate,
    itemFile,
    chatPostShowFlagMsgCopyMsgId,
    userSetting,
}) => {
    useTranslationSubscription();
    const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);

    // Id dùng để bật flag "リンクをコピーしました。" (tooltip xanh) trên đúng phần tử
    const copyFlagId = !Utils.isEmptyObject(itemFile) ? itemFile?.id : item?.id;

    const canCopyAttachmentShareLink = Boolean(
        !Utils.isEmptyObject(itemFile) &&
        !Utils.isEmptyString(itemFile?.shortKey) &&
        Utils.isEmptyString(ticketInfo?.deletedAt) &&
        !Utils.isEmptyObject(ticketInfo?.dataShareLink)
    );

    const canCopyMessageLink = isDisplayBtnCopyMsgId(item, ticketInfo, selectThread);
    const canShowHistory = isEditedMsg(editedMsgList, item) && Utils.isEmptyString(ticketInfo?.deletedAt);
    const canDelete = isDisplayBtnDelete(item);

    const hasMoreMenu = canCopyMessageLink || canCopyAttachmentShareLink || canShowHistory || canDelete;

    const showFlagMsgCopy = () => {
        if (!setChatPostShowFlagMsgCopyMsgId) return;
        setChatPostShowFlagMsgCopyMsgId(prev => ({ ...prev, [copyFlagId]: true }));
        setTimeout(() => {
            setChatPostShowFlagMsgCopyMsgId(prev => ({ ...prev, [copyFlagId]: false }));
        }, 3000);
    };

    const onClickCopyLink = shareLink => {
        if (Utils.isEmptyString(shareLink)) return;
        navigator.clipboard.writeText(shareLink);
        showFlagMsgCopy();
    };

    const onClickCopyMessageLink = () => onClickCopyLink(genMessageCopyShortLink(item));

    const onClickCopyFileLink = () =>
        onClickCopyLink(
            Utils.getShareLinkImg({
                attachFile: itemFile,
                dataShareLink: ticketInfo?.dataShareLink
            })
        );

    const onClickOpenHistory = () =>
        onOpenHistoryDialog(
            null,
            item,
            setIsOpenHistoryDialog,
            setIsLoadingHistoryList,
            setHistoryList,
            setMsgEditSelected,
            userChatList,
            userSetting
        );

    const onClickDeleteMsg = () => setOpenModalDeleteMsg({ isOpen: true, msg: item });

    const onClickEditMsg = () =>
        onClickShowEditMsg(
            null,
            item,
            setMsgEditSelected,
            setIsShowModalEditMsg,
            msgRefList,
            chatPostAllList,
            setChatPostUpdate
        );

    const moreMenuActions = [
        {
            key: 'copy-message-link',
            label: trI18n('CHATPOST-COPY-MESSAGE-LINK'),
            icon: '/assets/image/html-link-icon.svg',
            visible: canCopyMessageLink,
            onClick: onClickCopyMessageLink
        },
        {
            key: 'copy-file-link',
            label: trI18n('CHATPOST-COPY-FILE-LINK'),
            icon: '/assets/image/icon-copy-file.svg',
            visible: canCopyAttachmentShareLink,
            onClick: onClickCopyFileLink
        },
        {
            key: 'edit-history',
            label: trI18n('COMBTN016'),
            icon: '/assets/image/icon-time.svg',
            visible: canShowHistory,
            onClick: onClickOpenHistory
        },
        {
            key: 'delete',
            label: trI18n('COMBTN013'),
            icon: '/assets/image/delete-icon.svg',
            visible: canDelete,
            onClick: onClickDeleteMsg
        }
    ];

    return (
        <div className={`chatBox-tools${isMoreMenuOpen ? ' chatBox-tools--menu-open' : ''}`}>
            <ul>
                {isDisplayReactionBtn(ticketInfo, item, selectThread, isEnableChat) && (
                    <li>
                        <Tooltip title={trI18n('COMBTN015')} placement="top" arrow>
                            <IconButton
                                aria-describedby={reactionId}
                                onClick={event => {
                                    setReactionPopover(event.currentTarget);
                                    setReactionPopoverId(item.id);
                                }}
                            >
                                <img src="/assets/image/icon-reaction.svg" alt="" />
                            </IconButton>
                        </Tooltip>
                    </li>
                )}

                {isDisplayBtnEdit(item) && (
                    <li>
                        <Tooltip title={trI18n('COMBTN012')} placement="top" arrow>
                            <IconButton onClick={onClickEditMsg}>
                                <img src="/assets/image/edit-icon.svg" alt="" />
                            </IconButton>
                        </Tooltip>
                    </li>
                )}

                {hasMoreMenu && (
                    <li>
                        <MessageMoreMenu actions={moreMenuActions} onOpenChange={setIsMoreMenuOpen} />
                    </li>
                )}
            </ul>
        </div>
    );
};
